import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  communityWrapper: {
    display: 'flex',
    height: 96,
    width: '100%',
    gap: 8,
    backgroundColor: theme.palette.background.paper,
    padding: 8,
    borderRadius: 4,
    border: `1px solid ${theme.palette.background.paper}`,
    boxSizing: 'border-box',
    boxShadow: `0 1px 3px rgba(0, 0, 0, 0.1)`,
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      cursor: 'pointer',
    },
  },
  avatarWrapper: {
    minWidth: 100,
  },
  communityDetails: {
    display: 'flex',
    flexDirection: 'column',
  },
  infoWrapper: {
    flex: 1,
  },
  infoName: {
    fontWeight: 600,
  },
  controlWrapper: {},
  '.communityWrapper + .communityWrapper': {
    //todo think about it
    marginTop: 8,
  },
}));
